<template>
  <div>
    <b-card
      title="Channel Regions"
      class="mb-0"
    >
      <b-table
        class="position-relative"
        responsive
        :fields="tableFields"
        :items="regionOptions"
        show-empty
        hover
        outlined
        selectable
        select-mode="single"
        sticky-header
        :borderless="false"
        empty-text="No matching records found"
        @row-selected="onRowSelected"
      />

      <b-button
        v-b-modal.modal-region-add-new
        variant="success"
        class="float-right mr-2"
      >
        <feather-icon
          icon="PlusIcon"
        />
        Add New Method
      </b-button>
      <b-button
        variant="danger"
        class="float-right mr-2"
        @click.prevent="deleteConfirm"
      >
        <feather-icon
          icon="Trash2Icon"
        />
        Delete
      </b-button>
    </b-card>

    <b-modal
      id="modal-region-add-new"
      cancel-variant="outline-secondary"
      ok-title="Accept"
      cancel-title="Close"
      centered
      title="Add New Region"
      @ok="addNew"
    >
      <b-form>
        <b-form-group>
          <label for="region_id">Region ID</label>
          <b-form-input
            id="region_id"
            v-model="region.region_id"
            type="number"
            oninput="if(value.length > 4)value = value.slice(0, 4)"
          />
        </b-form-group>
        <b-form-group>
          <label for="region_code">Region Code</label>
          <b-form-input
            id="region_code"
            v-model="region.region_code"
            oninput="if(value.length > 3)value = value.slice(0, 3)"
          />
        </b-form-group>
        <b-form-group>
          <label for="region_name">Region Name</label>
          <b-form-input
            id="region_name"
            v-model="region.region_name"
            oninput="if(value.length > 32)value = value.slice(0, 32)"
          />
        </b-form-group>
        <b-form-group>
          <label for="region_currency">Region Currency</label>
          <b-form-input
            id="region_currency"
            v-model="region.region_currency"
            oninput="if(value.length > 3)value = value.slice(0, 3)"
          />
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BTable, BButton, BModal, VBModal, BForm, BFormInput, BFormGroup,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useChannelsJs from './channels'

const {
  saveChannelElement,
} = useChannelsJs()

export default {
  components: {
    BCard,
    BTable,
    BButton,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    regionOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selected: [],
      region: {
        region_id: '',
        region_name: '',
        region_code: '',
        region_currency: '',
      },
      tableFields: [
        { key: 'region_id', label: 'ID' },
        { key: 'region_code', label: 'Code' },
        { key: 'region_name', label: 'Name' },
        { key: 'region_currency', label: 'Local Currency' },
      ],
    }
  },
  methods: {
    onRowSelected(items) {
      this.selected = items
    },
    showAlert(icon, title, text) {
      this.$swal({
        icon,
        title,
        text,
        customClass: {
          confirmButton: `btn btn-${icon}`,
        },
      })
    },
    showToast(title, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title,
            icon: 'BellIcon',
            text,
            variant: 'warning',
          },
        },
        {
          position: 'top-center',
        },
      )
    },
    deleteConfirm() {
      if (this.selected < 1) {
        this.showToast('Warning', 'No Method Selected.')
        return
      }
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.delete()
        }
      })
    },
    delete() {
      const region = this.selected[0]
      const item = {
        index: 3,
        op: 'DELETE',
        data: region,
      }
      saveChannelElement(
        item,
        () => {
          this.showAlert('success', 'Success!', `${region.region_name} ${item.op} Done.`)
          this.$emit('updated')
        },
        fail => {
          this.showAlert('warning', 'Fail!', `${fail}`)
        },
      )
    },
    addNew() {
      const item = {
        index: 3,
        op: 'CREATE',
        data: this.region,
      }
      saveChannelElement(
        item,
        () => {
          this.showAlert('success', 'Success!', `${this.region.region_name} ${item.op} Done.`)
          this.$emit('updated')
        },
        fail => {
          this.showAlert('warning', 'Fail!', `${fail}`)
        },
      )
    },
  },
}
</script>
